import { heroTags } from "@/mocks/fengchiData";

export default function Hero() {
  return (
    <section id="top" className="relative pt-24 md:pt-32 pb-12 md:pb-20 bg-background-50 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] bg-cover bg-center pointer-events-none"
        aria-hidden="true"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20cinema%20marquee%20light%20bokeh%20against%20soft%20cream%20background%2C%20delicate%20golden%20glow%20particles%2C%20artistic%20editorial%20texture%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=fengchi-hero-bg-01&orientation=landscape)",
        }}
      />
      <div className="relative px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="animate-fadeUp">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium">
              <i className="ri-award-line" />
              持续维护的影评口碑参考站
            </span>

            <h1 className="mt-5 font-heading font-bold text-3xl md:text-5xl leading-tight text-foreground-950">
              风驰影院作品口碑总览：
              <span className="text-accent-600">好看吗？</span>
              先看评分与观后感
            </h1>

            <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-700 max-w-xl">
              想知道风驰影院的作品到底值不值得看？这里汇总了各作品的综合口碑、评分分布与真实观后感，
              从剧情、表演、摄影到节奏逐项拆解，帮你在按下播放键之前，先快速判断一部片子的整体方向。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#works"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-bar-chart-box-line" />
                查看作品评分榜
              </a>
              <a
                href="#reviews"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-900 text-sm md:text-base font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-article-line" />
                阅读深度影评
              </a>
            </div>

            <div className="mt-8">
              <p className="text-xs text-foreground-500 mb-3 flex items-center gap-1">
                <i className="ri-compass-3-line" />
                本站包含以下内容板块
              </p>
              <div className="flex flex-wrap gap-2">
                {heroTags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-800 text-xs md:text-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="relative animate-fadeUp">
            <div className="relative rounded-lg overflow-hidden w-full aspect-[4/3] lg:aspect-[5/5] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20amber%20cinema%20interior%20with%20rows%20of%20empty%20red%20velvet%20seats%20bathed%20in%20a%20single%20golden%20spotlight%2C%20soft%20bokeh%20and%20film%20grain%2C%20artistic%20editorial%20mood%2C%20moody%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1000&height=1000&seq=fengchi-hero-poster-01&orientation=squarish"
                alt="暖色调的影院放映厅场景，作为风驰影院口碑站的封面插图"
                title="风驰影院 口碑 评分 影评"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
              <div className="absolute left-4 md:left-6 bottom-4 md:bottom-6 right-4">
                <p className="font-heading text-lg md:text-2xl font-bold text-background-50">
                  用口碑做决定，把时间留给好作品
                </p>
                <p className="text-background-100/90 text-xs md:text-sm mt-1">
                  评分 · 影评 · 观后感，一站看全
                </p>
              </div>
            </div>

            <div className="absolute -left-3 md:-left-6 top-6 md:top-10 bg-background-50 border border-background-200 rounded-lg px-4 py-3 w-[150px] md:w-[176px]">
              <p className="text-xs text-foreground-500">综合口碑均分</p>
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600 leading-none mt-1">
                8.42
              </p>
              <div className="flex items-center gap-1 mt-2 text-accent-600 text-xs">
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-half-fill" />
                <span className="text-foreground-500 ml-1">128 万条</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}